import { createNextTableContext } from '@shared/modules/next-table/context/context';

export const DnsTableContext = createNextTableContext();
